export const RESET_SERVICE_TRIBUTES = 'NFSE_TRIBUTES/RESET_SERVICE_TRIBUTES';
export const SET_SUMMARY_SERVICE_TRIBUTES = 'NFSE_TRIBUTES/SET_SUMMARY_SERVICE_TRIBUTES';
export const SET_PAGINATION_SERVICE_TRIBUTES = 'NFSE_TRIBUTES/SET_PAGINATION_SERVICE_TRIBUTES';
export const SET_DETAILED_SERVICE_TRIBUTES = 'NFSE_TRIBUTES/SET_DETAILED_SERVICE_TRIBUTES';
export const SET_TRIBUTES_WARNINGS = 'NFSE_TRIBUTES/SET_TRIBUTES_WARNINGS';
